import { render } from "./Payouts.vue?vue&type=template&id=ac65e2da"
import script from "./Payouts.vue?vue&type=script&lang=js"
export * from "./Payouts.vue?vue&type=script&lang=js"

import "./Payouts.vue?vue&type=style&index=0&id=ac65e2da&lang=css"

import exportComponent from "/opt/streamify/admin/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__